import { render, staticRenderFns } from "./_tag.vue?vue&type=template&id=60888bbc&"
import script from "./_tag.vue?vue&type=script&lang=ts&"
export * from "./_tag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports